import { useState } from "react";
import { ChevronRight, Folder, FolderOpen, FileCode2 } from "lucide-react";

// Recursive tree rendered through a lookup object (direct self-reference breaks the dev build plugin).
const Tree = {};

export const fmtBytes = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : n >= 1024 ? `${Math.round(n / 1024)} KB` : `${n} B`);

const TreeNode = ({ node, depth, q, path }) => {
  const [open, setOpen] = useState(depth < 1);
  const isDir = node.type === "dir";
  const show = open || !!q;
  if (!isDir) {
    return (
      <li className="flex items-center gap-2 py-0.5 text-[13px] text-slate-600" style={{ paddingLeft: depth * 16 + 22 }} data-testid={`tree-file-${path}`}>
        <FileCode2 size={13} className="text-slate-400 shrink-0" /> <span className="truncate">{node.name}</span>
        <span className="ml-auto text-[11px] text-slate-400 tabular-nums">{fmtBytes(node.size)}</span>
      </li>
    );
  }
  return (
    <li>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-1.5 py-1 text-[13px] font-semibold text-[#12234A] hover:bg-slate-50 rounded" style={{ paddingLeft: depth * 16 }} data-testid={`tree-dir-${path}`}>
        <ChevronRight size={14} className={`transition-transform ${show ? "rotate-90" : ""}`} />
        {show ? <FolderOpen size={14} className="text-[#F5551E]" /> : <Folder size={14} className="text-[#F5551E]" />}
        <span className="truncate">{node.name}</span>
        <span className="ml-auto text-[11px] font-normal text-slate-400 tabular-nums">{node.files} files · {fmtBytes(node.size)}</span>
      </button>
      {show && <ul>{node.children.map((c) => <Tree.Node key={c.name} node={c} depth={depth + 1} q={q} path={`${path}/${c.name}`} />)}</ul>}
    </li>
  );
};

const filterTree = (node, q) => {
  if (!q) return node;
  if (node.type === "file") return node.name.toLowerCase().includes(q) ? node : null;
  const kids = node.children.map((c) => filterTree(c, q)).filter(Boolean);
  return kids.length || node.name.toLowerCase().includes(q) ? { ...node, children: kids } : null;
};

Tree.Node = TreeNode;

export const FolderTree = ({ tree, q }) => {
  const roots = tree.map((t) => filterTree(t, q)).filter(Boolean);
  if (!roots.length) return <p className="text-sm text-slate-400">No files match.</p>;
  return <ul className="font-mono" data-testid="sitemap-tree">{roots.map((t) => <TreeNode key={t.name} node={t} depth={0} q={q} path={t.name} />)}</ul>;
};
